import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useClusterStore = defineStore('clusterStore', () => {
  const ids = ref([])

  return { ids }

})
